import { Button, Drawer, Select, Upload, UploadProps } from 'antd';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import {
  IEnvImportCheck,
  IGameEnvModel,
} from '../../../../model/api-modules/env';
import {
  CommonStatusStep,
  IAPIGameItem,
  IAPIServiceConfigItem,
} from '../../../../model/api-modules';
import getFormatMessage from '../../../../locales/get-format-message';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload';
import { messageError, messageWarning } from '../../../../components/message';
import { useEffect, useState } from 'react';
// import {
//     currentSiteDownloadUpload,
// } from '../../../admin/download/lib/multi-site-cos';
import uploadIcon from '../../../../assets/svg/cloud-upload.svg';
import loadingIcon from '../../../../assets/svg/loading-sync.svg';
import successIcon from '../../../../assets/svg/success-circle-fill.svg';
import fileIcon from '../../../../assets/svg/file-safety-filled.svg';
import errorIcon from '../../../../assets/svg/error-icon.svg';
// import COS from '@tencent/new-cos-js-sdk-v5';
import {
  getImportFileUrl,
  putImportObject,
} from '../../../studio/lib/import-cos';
import { envImport, envImportCheck } from '../../../../api/game/env';
import { getLocalTime } from '../../../../lib';
import { useHistory } from 'react-router-dom';

interface IProps {
  readonly visible: boolean;
  readonly onClose: () => void;
  readonly envList: ReadonlyArray<IGameEnvModel>;
  readonly selectedGame?: IAPIGameItem;
  readonly allServiceConfig: ReadonlyArray<IAPIServiceConfigItem> | null;
}
export const EnvImport = (props: IProps) => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [envOptions, setEnvOptions] = useState<
    ReadonlyArray<{ label: JSX.Element; value: Number }>
  >([]);
  const [selectEnv, setSelectEnv] = useState<Number | null>(null);
  const [uploadStep, setUploadStep] = useState<CommonStatusStep>(
    CommonStatusStep.Pending
  );
  const [fileCheckData, setFileCheckData] = useState<IEnvImportCheck | null>(
    null
  );
  const [importTask, setImportTask] = useState<Record<string, any>>({});
  const [fileName, setFileName] = useState<string>('');
  const [fileUrl, setFileUrl] = useState<string>('');
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  useEffect(() => {
    setEnvOptions(
      props.envList.map((env) => {
        const gos = JSON.parse(env.GosParams || '{}');
        const version = gos?.GameServiceVersion || '';
        return {
          label: (
            <div className="export-env-select-item">
              <span className="export-item-name">{env.Name}</span>
              {version && (
                <span className="export-item-version">{version}</span>
              )}
            </div>
          ),
          value: env.id,
        };
      })
    );
  }, props.envList);

  const cleanData = () => {
    setUploadStep(CommonStatusStep.Pending);
    setFileCheckData(null);
    setImportTask({});
    setFileName('');
    setFileUrl('');
  };

  const handleEnvChange = (value: Number) => {
    setSelectEnv(value);
    cleanData();
  };

  const onClose = () => {
    props.onClose();
    setSelectEnv(null);
    cleanData();
  };

  const beforeUpload = () => {
    // 取消默认上传行为
    return false;
  };

  const handleUpload: UploadProps['onChange'] = async (
    info: UploadChangeParam<UploadFile>
  ) => {
    if (btnLoading) {
      return;
    }
    const files = Object.assign([], [info.file]);
    console.log('上传文件:', files);
    const file: any = files[0];
    if (file.size > 10 * 1024 * 1024) {
      messageError(getFormatMessage('import_upload_exceed_tips'));
      return false;
    }
    const splitArr = file.name.split('.');
    if (splitArr[splitArr.length - 1] !== 'enc') {
      messageWarning(getFormatMessage('package_support'));
      return false;
    }
    uploadTo(files);
    return false;
  };
  // 上传
  const uploadTo = async (files: ReadonlyArray<File>) => {
    setLoading(true);
    // 先清空原本数据 避免某接口报错导致数据不一致
    cleanData();
    // const uploadURL: string[] = [];

    const file: any = files[0];

    if (file.status && file.status === 'removed') {
      console.log('删除该文件', file.name);
      return;
    }

    setFileName(file.name);
    const fileName = `${new Date().getTime()}/${file.name}`;
    const envItem = props.envList.find((item) => item.id === selectEnv);
    if (props.selectedGame?.gameID && selectEnv && envItem) {
      await putImportObject(
        fileName,
        file,
        props.selectedGame.gameID,
        selectEnv.toString(),
        envItem.Guid
      );
      const url = await getImportFileUrl(
        props.selectedGame.gameID,
        selectEnv.toString(),
        envItem.Guid,
        fileName
      );
      if (url) {
        checkFile(url);
        setFileUrl(url);
        return;
      }
    }
    setLoading(false);
    setUploadStep(CommonStatusStep.Reject);
    messageError(getFormatMessage('fail_to_upload'));
  };

  const extractPath = (url: string) => {
    // 找到域名结束的位置（第二个 /）
    const domainEndIndex = url.indexOf('/', url.indexOf('//') + 2);

    if (domainEndIndex === -1) return '';

    // 找到查询参数开始的位置
    const queryStartIndex = url.indexOf('?', domainEndIndex);

    if (queryStartIndex === -1) {
      // 如果没有查询参数，返回从域名后到结尾的部分
      return url.substring(domainEndIndex);
    }

    // 返回域名后到查询参数前的部分
    return url.substring(domainEndIndex, queryStartIndex);
  };

  const checkFile = async (url: string) => {
    const envItem = props.envList.find((item) => item.id === selectEnv);
    if (props.selectedGame && envItem && url) {
      const res = await envImportCheck({
        game_id: Number(props.selectedGame.gameID),
        env_id: envItem.Guid,
        package_fs_id: extractPath(url),
        gameID: props.selectedGame.gameID,
        envID: envItem.id.toString(),
      });
      if (res?.code === 0) {
        setUploadStep(CommonStatusStep.Resolve);
        setFileCheckData(res);
        setLoading(false);
        return;
      }
    }
    setUploadStep(CommonStatusStep.Reject);
    setLoading(false);
  };

  const clickDelete = () => {
    if (btnLoading) {
      return;
    }
    cleanData();
  };

  const renderUpload = () => {
    if (loading) {
      return (
        <>
          <img src={loadingIcon} className="loading-icon" />
          <div>{getFormatMessage('uploading')}</div>
        </>
      );
    }
    if (uploadStep === CommonStatusStep.Resolve) {
      return (
        <>
          <div className="success-name-box">
            <img src={successIcon} className="success-icon" />
            <div>{fileName}</div>
          </div>
          <div className="success-btn-box">
            <img src={fileIcon} className="file-icon" />
            <span>{getFormatMessage('file_check_tips')}</span>
            {btnLoading ? (
              <div
                className="success-btn-item"
                style={{ cursor: 'not-allowed' }}
              >
                {getFormatMessage('file_change')}
              </div>
            ) : (
              <Upload
                beforeUpload={beforeUpload}
                onChange={handleUpload}
                fileList={[]}
              >
                <div className="success-btn-item">
                  {getFormatMessage('file_change')}
                </div>
              </Upload>
            )}
            <div
              className="success-btn-item"
              onClick={clickDelete}
              style={{ cursor: btnLoading ? 'not-allowed' : 'pointer' }}
            >
              {getFormatMessage('delete')}
            </div>
          </div>
        </>
      );
    }
    if (uploadStep === CommonStatusStep.Reject) {
      return (
        <>
          <div className="success-name-box">
            <img src={errorIcon} className="success-icon" />
            <div>{fileName}</div>
          </div>
          <div className="success-btn-box">
            <span>{getFormatMessage('fail_to_upload')} ｜</span>
            {btnLoading ? (
              <div
                className="success-btn-item"
                style={{ cursor: 'not-allowed' }}
              >
                {getFormatMessage('file_change')}
              </div>
            ) : (
              <Upload
                beforeUpload={beforeUpload}
                onChange={handleUpload}
                fileList={[]}
              >
                <div className="success-btn-item">
                  {getFormatMessage('file_change')}
                </div>
              </Upload>
            )}
            <div
              className="success-btn-item"
              onClick={clickDelete}
              style={{ cursor: btnLoading ? 'not-allowed' : 'pointer' }}
            >
              {getFormatMessage('delete')}
            </div>
          </div>
        </>
      );
    }
    return (
      <Upload beforeUpload={beforeUpload} onChange={handleUpload} fileList={[]}>
        <div style={{ cursor: 'pointer' }}>
          <img src={uploadIcon} className="upload-icon" />
          <p className="files">
            {getFormatMessage('drag_tips')}
            <span> {getFormatMessage('upload')}</span>
          </p>
          <p>{getFormatMessage('package_support')}</p>
        </div>
      </Upload>
    );
  };

  const handleOkImport = async () => {
    const envItem = props.envList.find((item) => item.id === selectEnv);
    if (props.selectedGame && envItem && fileUrl) {
      setBtnLoading(true);
      const res = await envImport({
        game_id: Number(props.selectedGame.gameID),
        env_id: envItem.Guid,
        package_fs_id: extractPath(fileUrl),
        gameID: props.selectedGame.gameID,
        envID: envItem.id.toString(),
      });
      if (res?.code === 0 && res?.result?.k8s_app_task_id) {
        setImportTask(res?.result);
      }
      setBtnLoading(false);
    }
  };

  const footer = () => {
    if (!importTask?.k8s_app_task_id) {
      const envItem = props.envList.find((env) => env.id === selectEnv);
      const gos = JSON.parse(envItem?.GosParams || '{}');
      return (
        <div>
          <Button
            className="gc-btn-default sync-cancel"
            style={{ width: '80px', borderRadius: '4px' }}
            onClick={onClose}
          >
            {getFormatMessage('cancel')}
          </Button>
          <Button
            loading={loading || btnLoading}
            onClick={handleOkImport}
            className="gc-btn gc-btn-primary"
            style={{ minWidth: '80px', borderRadius: '4px' }}
            disabled={
              !fileCheckData?.result?.gaas_version ||
              !gos?.GameServiceVersion ||
              fileCheckData?.result?.gaas_version !== gos?.GameServiceVersion
            }
          >
            {getFormatMessage('create_import_task')}
          </Button>
        </div>
      );
    }
    return null;
  };

  const viewTask = () => {
    const envItem = props.envList.find(
      (item) => item.Guid === importTask?.env_id
    );
    history.push(
      `/studio/${props.selectedGame?.studioID}/audithub?gameId=${props.selectedGame?.gameID}&envId=${envItem?.Guid}&task=sync&subtask=534&taskId=${importTask?.k8s_app_task_id}`
    );
  };

  const renderService = (value: string) => {
    if (value === 'api-control') {
      return 'Client API Control';
    }
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const renderImportContent = () => {
    const orgEnv = props.envList.find(
      (item) => item.Guid === fileCheckData?.result?.source_env_id
    );
    const envItem = props.envList.find((env) => env.id === selectEnv);
    const gos = JSON.parse(envItem?.GosParams || '{}');
    if (importTask?.k8s_app_task_id) {
      const envItem = props.envList.find(
        (item) => item.Guid === importTask?.env_id
      );
      return (
        <div className="export-success-box">
          <img src={successIcon} className="export-success-icon" />
          <div className="export-success-title">
            {getFormatMessage('import_task_created_successfully')}
          </div>
          <div className="export-success-tips">
            <div>{getFormatMessage('import_tips_one')}</div>
            <div>{getFormatMessage('import_close_tips')}</div>
          </div>
          <div className="export-success-btn">
            <Button
              className="gc-btn-default sync-cancel"
              style={{ width: 128 }}
              onClick={onClose}
            >
              {getFormatMessage('close')}
            </Button>
            <Button
              className="gc-btn gc-btn-primary"
              style={{ width: 128 }}
              onClick={viewTask}
            >
              {getFormatMessage('go_to_view')}
            </Button>
          </div>
          <div className="export-success-table">
            <div
              className="table-col"
              style={{ borderBottom: '1px solid #E5E6EB' }}
            >
              <div className="table-col-item">
                <div>{getFormatMessage('task_id')}</div>
                <div className="table-col-item-value">
                  {importTask?.k8s_app_task_id || ''}
                </div>
              </div>
            </div>
            <div
              className="table-col"
              style={{ borderBottom: '1px solid #E5E6EB' }}
            >
              <div className="table-col-item">
                <div>{getFormatMessage('org_env')}</div>
                <div className="table-col-item-value">{orgEnv?.Name || ''}</div>
              </div>
              <div className="table-col-item">
                <div>{getFormatMessage('tar_env')}</div>
                <div className="table-col-item-value">
                  {envItem?.Name || ''}
                </div>
              </div>
            </div>
            <div className="table-col">
              <div className="table-col-item">
                <div>{getFormatMessage('approval_version')}</div>
                <div className="table-col-item-value">
                  {importTask?.api_version || ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="import-env-box">
        <div className="import-env-tips">
          {getFormatMessage('select_env_and_upload')}
        </div>
        <div className="import-env-label">{getFormatMessage('tar_env')}</div>
        <Select
          className="export-select"
          style={{ height: 32 }}
          options={envOptions.slice()}
          virtual={false}
          onChange={handleEnvChange}
          value={selectEnv}
          disabled={btnLoading || loading}
        />
        {fileCheckData?.result?.gaas_version &&
          gos?.GameServiceVersion &&
          fileCheckData?.result?.gaas_version !== gos?.GameServiceVersion && (
            <div className="import-select-error">
              <img src={errorIcon} />
              <span>
                {getFormatMessage('version_error_tips', {
                  params: {
                    tarVersion: gos?.GameServiceVersion || '',
                    orgVersion: fileCheckData?.result?.gaas_version || '',
                  },
                })}
              </span>
            </div>
          )}
        {selectEnv && (
          <>
            <div className="import-env-label">
              {getFormatMessage('upload_package')}
            </div>
            <div className="upload-container">{renderUpload()}</div>
          </>
        )}
        {fileCheckData?.code === 0 && (
          <>
            <div>{getFormatMessage('package_info')}</div>
            <div className="import-info-table">
              <div className="table-col">
                <div className="table-col-item">
                  <div>{getFormatMessage('org_env')}</div>
                  <div className="table-col-item-value">
                    {orgEnv?.Name || ''}
                  </div>
                </div>
                <div className="table-col-item">
                  <div>{getFormatMessage('approval_version')}</div>
                  <div className="table-col-item-value">
                    {fileCheckData?.result?.gaas_version || ''}
                  </div>
                </div>
              </div>
              <div className="table-col">
                <div className="table-col-item">
                  <div>{getFormatMessage('export_time')}</div>
                  <div className="table-col-item-value">
                    {getLocalTime(fileCheckData?.result?.export_time || '')}
                  </div>
                </div>
              </div>
              <div className="table-col" style={{ borderBottom: 'none' }}>
                <div className="table-col-item" style={{ width: '100%' }}>
                  <div>{getFormatMessage('include_services')}</div>
                  <div className="table-col-item-value">
                    {fileCheckData?.result?.console_services &&
                      fileCheckData?.result?.console_services?.length !== 0 &&
                      fileCheckData?.result?.console_services.map(
                        (item: string) => {
                          return (
                            <div className="service-item">
                              {renderService(item)}
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };
  return (
    <Drawer
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '1px solid #E5E6EB',
            paddingBottom: 10,
          }}
        >
          <div style={{ display: 'flex' }}>
            <span>{getFormatMessage('import_environment_configuration')}</span>
          </div>
          <img src={closeIcon} className="sync-close-icon" onClick={onClose} />
        </div>
      }
      visible={props.visible}
      onClose={onClose}
      width={720}
      closable={false}
      footer={footer()}
    >
      {renderImportContent()}
    </Drawer>
  );
};
